import { render, staticRenderFns } from "./editBaseSet.vue?vue&type=template&id=82afce46&scoped=true&"
import script from "./editBaseSet.vue?vue&type=script&lang=js&"
export * from "./editBaseSet.vue?vue&type=script&lang=js&"
import style0 from "./editBaseSet.vue?vue&type=style&index=0&id=82afce46&prod&lang=less&scoped=true&"
import style1 from "./editBaseSet.vue?vue&type=style&index=1&id=82afce46&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82afce46",
  null
  
)

export default component.exports